export default "__VITE_ASSET__CTBi5kQf__"